import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getDocDownloadUrl } from "../../../app/firestore/firebaseService";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { getDocAndUrl } from "../../docs/docSlice";
import { PartyDocFillDashboard } from "../partyDocFill/PartyDocFillDashboard";
import PartyDocSignPage from "../partyDocSign/PartyDocSignPage";
import PartyDocViewDashboard from "../partyDocView/PartyDocViewDashboard";

export default function PartyDocEditPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { doc, docUrl } = useSelector((state) => state.doc);
  const { docsForParty } = useSelector((state) => state.party);
  let { docId, partyId } = useParams();
  const location = useLocation();
  const lastPath = location.pathname.substring(
    location.pathname.lastIndexOf("/") + 1
  );
  // Guards against firing the "no longer available" toast/redirect more than
  // once while this component is unmounting (docsForParty can update again
  // before the navigate() below takes effect).
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    // docsForParty.docs is undefined until the party's shared-docs listener
    // has delivered its first snapshot - wait for that before deciding
    // whether this doc is present.
    if (!docsForParty?.docs) return;

    const newDoc = docsForParty.docs.find((doc) => doc.id === docId);
    if (newDoc) {
      getDocDownloadUrl(newDoc.docRef).then((url) => {
        dispatch(getDocAndUrl({ doc: newDoc, docUrl: url }));
      });
    } else if (!hasRedirectedRef.current) {
      // The doc isn't (or is no longer) shared with this party - most often
      // because the agent unshared it while it was open. Bounce back to the
      // party's documents page instead of leaving the "Loading..." spinner
      // stuck forever.
      hasRedirectedRef.current = true;
      toast.error("This document is no longer available to you.");
      navigate(`/party/${partyId}/documents`, { replace: true });
    }
  }, [doc.docRef, docsForParty, docId, partyId, dispatch, navigate]);

  // doc.id !== docId is for switching documents and making sure we
  // have new document loaded in store
  if (!doc.id || !doc.docRef || !lastPath || doc.id !== docId || !docUrl) {
    return <LoadingComponent />;
  }

  return (
    <>
      {lastPath === "fill" && <PartyDocFillDashboard />}
      {lastPath === "sign" && <PartyDocSignPage />}
      {lastPath === "view" && <PartyDocViewDashboard />}
    </>
  );
}
